import { Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthModuleConfig, OAuthService } from "angular-oauth2-oidc";

@Injectable({
  providedIn: 'root'
})
export class DefaultOAuthInterceptor implements HttpInterceptor {

  constructor(private oauthService: OAuthService,
    @Optional() private moduleConfig: OAuthModuleConfig) {
  }

  private checkUrl(url: string): boolean {
    // Check if the provided URL starts with any of the allowed URLs defined in the module configuration
    const found = this.moduleConfig.resourceServer.allowedUrls?.find(u => url.startsWith(u));

    // Return true if a matching allowed URL is found, otherwise return false
    return found != null;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Convert the request URL to lowercase for consistent comparison
    const url = request.url.toLowerCase();

    // If module configuration is not loaded, pass the request to the next handler without modification
    if (!this.moduleConfig) return next.handle(request);

    // If resource server configuration is missing, pass the request to the next handler
    if (!this.moduleConfig.resourceServer) return next.handle(request);

    // If no allowed URLs are defined, pass the request to the next handler
    if (!this.moduleConfig.resourceServer.allowedUrls) return next.handle(request);

    // Check if the request URL is allowed; if not, pass it through unchanged
    if (!this.checkUrl(url)) return next.handle(request);

    // If a valid access token exists, clone the request and add the Authorization header with the token
    if (this.oauthService.hasValidAccessToken()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.oauthService.getIdToken()}` // Set the Authorization header with Bearer token
        }
      });
    }

    // Pass the modified or unmodified request to the next handler in the chain
    return next.handle(request);
  }
}